import { formatedMinNotional } from "../../../utils/env";

type MinNotionalErrorCurrencyProps = {
  currency: string;
};

export default function MinNotionalErrorCurrency({
  currency,
}: MinNotionalErrorCurrencyProps): JSX.Element {
  return (
    <span className="message__note message__note--error">
      {`Minimum ${formatedMinNotional} ${currency.toUpperCase()} required`}
    </span>
  );
}
